export var loadGoogleTagManager = function (containerId) {
    window.dataLayer = [
        {
            event: 'gtm.js',
            'gtm.start': new Date().getTime(),
        },
    ];
    var gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=".concat(containerId);
    document.head.appendChild(gtmScript);
};
export var push = function (entry) {
    var _a;
    (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(entry);
};
